var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m365.199219 261.398438 8.699219 52.199218-29.699219 4.800782h-176.398438l-29.699219-4.800782 8.699219-52.199218-107.398437-105.898438 149.097656-22.199219 67.5-133.300781 67.5 133.300781 149.097656 22.199219zm0 0",
    fill: "#ffda2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m365.199219 261.398438 8.699219 52.199218-29.699219 4.800782h-88.199219v-318.398438l67.5 133.300781 149.097656 22.199219zm0 0",
    fill: "#fdbf00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m345.097656 197.199219-61.5-9.300781-27.597656-55.5-27.597656 55.5-61.5 9.300781 44.398437 43.5-10.203125 60.898437 54.902344-28.496094 54.902344 28.496094-10.203125-60.898437zm0 0",
    fill: "#fdbf00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m300.699219 240.699219 10.203125 60.898437-54.902344-28.496094v-140.703124l27.597656 55.5 61.5 9.300781zm0 0",
    fill: "#ff9100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m512 361h-181v151h181l-37.5-76zm0 0",
    fill: "#f03800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0 361 37.5 75-37.5 76h181v-151zm0 0",
    fill: "#ff641a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m91 301v150h330v-150zm0 0",
    fill: "#ff9100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m256 301h165v150h-165zm0 0",
    fill: "#ff641a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m181 361h30v30h-30zm0 0",
    fill: "#ffda2d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m241 361h30v30h-30zm0 0",
    fill: "#ffda2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fdbf00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m301 361h30v30h-30zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 361h15v30h-15zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/winner.4a1f04a1b7908d74165db3734e1e14b4.svg";
export { ForwardRef as ReactComponent };